"use client";

import { useEffect, useState } from "react";
import { localeNames, locales, LOCALE_COOKIE, type Locale } from "@/i18n/locales";
import { useI18n } from "@/i18n/provider";

const labels: Record<Locale, string> = {
  en: "Language", ko: "언어", ja: "言語", "zh-TW": "語言", fr: "Langue", es: "Idioma", pt: "Idioma",
};

export function LanguageSwitcher() {
  const { locale } = useI18n();
  const [changing, setChanging] = useState(false);
  useEffect(() => {
    // Back/forward cache restores component state from before navigation.
    // A pending language switch must not leave the restored selector disabled.
    const restored = () => setChanging(false);
    window.addEventListener("pageshow", restored);
    return () => window.removeEventListener("pageshow", restored);
  }, []);
  function changeLanguage(value: string) {
    if (value === locale) return;
    setChanging(true);
    document.cookie = `${LOCALE_COOKIE}=${value}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`;
    const url = new URL(window.location.href);
    url.searchParams.set("lang", value);
    // A full navigation refreshes the server layout, metadata and client messages together.
    window.location.assign(url.href);
  }
  return <label className="language-switcher"><span className="sr-only">{labels[locale]}</span><span aria-hidden="true">◎</span><select aria-label={labels[locale]} value={locale} disabled={changing} onChange={(event) => changeLanguage(event.target.value)}>{locales.map((value) => <option key={value} value={value} lang={value}>{localeNames[value]}</option>)}</select></label>;
}
